import { render, staticRenderFns } from "./ModelPlatform.vue?vue&type=template&id=5ba6b26c&scoped=true"
import script from "./ModelPlatform.vue?vue&type=script&lang=js"
export * from "./ModelPlatform.vue?vue&type=script&lang=js"
import style0 from "./ModelPlatform.vue?vue&type=style&index=0&id=5ba6b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6b26c",
  null
  
)

export default component.exports